export const LOGO_MARK_SRC = '/lightstrike-logo.svg'
export const LOGO_WORDMARK_SRC = '/lightstrike-logo-2026.png'
export const LOGO_ALT = 'Lightstrike'

export const LOGO_SIZE_HERO = 56
export const LOGO_SIZE_FOOTER = 28
export const LOGO_SIZE_LEGAL_HEADER = 24
